<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <div class="flex-grow-1 overflow-auto px-3 pb-3 pt-3">

      <!-- Cabecera -->
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h4 class="fw-bold mb-0">Contabilidad</h4>
          <small class="text-muted">Exportaciones e informes para el sistema contable</small>
        </div>
      </div>

      <!-- Tarjetas -->
      <div class="row g-4">

        <!-- Exportar Contasis -->
        <div class="col-md-6 col-lg-4">
          <div class="card h-100 border-0 shadow-sm">
            <div class="card-body d-flex flex-column p-4">
              <div class="d-flex align-items-center mb-3">
                <div class="rounded-3 p-3 me-3" style="background:#eef2ff">
                  <img src="../../assets/img/icons/reports.svg" alt=""
                    style="width:28px;height:28px;filter:invert(33%) sepia(80%) saturate(500%) hue-rotate(200deg)">
                </div>
                <div>
                  <h6 class="mb-0 fw-semibold">Exportar Ventas a Contasis</h6>
                  <small class="text-muted">Registro de ventas para el sistema contable</small>
                </div>
              </div>
              <p class="text-muted small flex-grow-1">
                Genera el Excel con Base Imponible e IGV por cada comprobante, listo para importar en Contasis.
              </p>
              <div class="row g-2 mb-3">
                <div class="col-6">
                  <label class="form-label small fw-medium mb-1">Mes inicio</label>
                  <select class="form-select form-select-sm" v-model="contasis.mesInicio">
                    <option v-for="m in meses" :key="m.value" :value="m.value">{{ m.label }}</option>
                  </select>
                </div>
                <div class="col-6">
                  <label class="form-label small fw-medium mb-1">Mes fin</label>
                  <select class="form-select form-select-sm" v-model="contasis.mesFin">
                    <option v-for="m in meses" :key="m.value" :value="m.value">{{ m.label }}</option>
                  </select>
                </div>
                <div class="col-12">
                  <label class="form-label small fw-medium mb-1">Serie (opcional)</label>
                  <input type="text" class="form-control form-control-sm" v-model="contasis.serie"
                    placeholder="Ej: B002, F001 — vacío para todas" />
                </div>
              </div>
              <button class="btn btn-primary w-100 d-flex align-items-center justify-content-center gap-2"
                :disabled="contasis.loading || !contasis.mesInicio || !contasis.mesFin"
                @click="descargarContasis">
                <span v-if="contasis.loading" class="spinner-border spinner-border-sm"></span>
                <img v-else src="../../assets/img/icons/download.svg" alt=""
                  style="width:16px;height:16px;filter:brightness(0) invert(1)">
                {{ contasis.loading ? 'Generando...' : 'Descargar Excel' }}
              </button>
              <div v-if="contasis.error" class="alert alert-danger mt-2 mb-0 py-2 small">{{ contasis.error }}</div>
              <div v-if="contasis.ok" class="alert alert-success mt-2 mb-0 py-2 small">Archivo descargado correctamente</div>
            </div>
          </div>
        </div>

        <!-- Placeholder: Comprobantes Electrónicos -->
        <div class="col-md-6 col-lg-4">
          <div class="card h-100 border-0" style="border:2px dashed #dee2e6 !important;background:#fafafa">
            <div class="card-body d-flex flex-column align-items-center justify-content-center p-4 text-center">
              <div class="rounded-3 p-3 mb-3" style="background:#f1f3f5">
                <img src="../../assets/img/icons/dollar-circle.svg" alt="" style="width:28px;height:28px;opacity:.4">
              </div>
              <h6 class="text-muted fw-semibold mb-1">Comprobantes Electrónicos</h6>
              <small class="text-muted">Próximamente — historial enviado a SUNAT</small>
            </div>
          </div>
        </div>

        <!-- Placeholder: Libro de Compras -->
        <div class="col-md-6 col-lg-4">
          <div class="card h-100 border-0" style="border:2px dashed #dee2e6 !important;background:#fafafa">
            <div class="card-body d-flex flex-column align-items-center justify-content-center p-4 text-center">
              <div class="rounded-3 p-3 mb-3" style="background:#f1f3f5">
                <img src="../../assets/img/icons/moneys.svg" alt="" style="width:28px;height:28px;opacity:.4">
              </div>
              <h6 class="text-muted fw-semibold mb-1">Libro de Compras</h6>
              <small class="text-muted">Próximamente — exportación del registro de compras</small>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import MainHeader  from '../../components/Layouts/MainHeader.vue';
import MainSidebar from '../../components/Layouts/MainSidebar.vue';
import api from '../../services/api';

export default {
  name: 'ContabilidadPage',
  components: { MainHeader, MainSidebar },
  data() {
    const now  = new Date();
    const yyyy = now.getFullYear();
    const mesActual = `${yyyy}-${String(now.getMonth() + 1).padStart(2, '0')}`;

    // Generar lista de meses: desde 2023-01 hasta mes actual
    const meses = [];
    const MESES_ES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];
    let y = 2023, m = 1;
    const [fy, fm] = mesActual.split('-').map(Number);
    while (y < fy || (y === fy && m <= fm)) {
      meses.push({ value: `${y}-${String(m).padStart(2,'0')}`, label: `${MESES_ES[m-1]} ${y}` });
      m++; if (m > 12) { m = 1; y++; }
    }
    meses.reverse();

    return {
      meses,
      contasis: {
        mesInicio: mesActual,
        mesFin:    mesActual,
        serie: '',
        loading: false,
        error: '',
        ok: false,
      },
    };
  },
  methods: {
    async descargarContasis() {
      this.contasis.loading = true;
      this.contasis.error   = '';
      this.contasis.ok      = false;
      try {
        // Calcular primer y último día de los meses seleccionados
        const [y1, m1] = this.contasis.mesInicio.split('-').map(Number);
        const [y2, m2] = this.contasis.mesFin.split('-').map(Number);
        const f1 = `${y1}-${String(m1).padStart(2,'0')}-01`;
        const f2 = new Date(y2, m2, 0).toISOString().slice(0, 10);

        const params = { f1, f2 };
        if (this.contasis.serie.trim()) params.serie = this.contasis.serie.trim();

        const resp = await api.get('/facturacion/exportar-contasis', {
          params,
          responseType: 'blob',
        });

        const url  = URL.createObjectURL(resp.data);
        const a    = document.createElement('a');
        a.href     = url;
        a.download = `ventas_contasis_${this.contasis.mesInicio}_${this.contasis.mesFin}.xlsx`;
        a.click();
        URL.revokeObjectURL(url);
        this.contasis.ok = true;
      } catch (e) {
        this.contasis.error = e.response?.data?.error || 'Error al generar el archivo';
      } finally {
        this.contasis.loading = false;
      }
    },
  },
};
</script>
